import { render, staticRenderFns } from "./ComboNovoAtendimento.vue?vue&type=template&id=0830fe5a"
import script from "./ComboNovoAtendimento.vue?vue&type=script&lang=ts"
export * from "./ComboNovoAtendimento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports